// @ts-nocheck
import GenericRenderContainerSection from './GenericRenderContainerSection';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import { useNavigate } from 'react-router-dom';
import RenderSingleMatchCard from './SingleMatchCardPrimeArchivioFunctions/RenderSingleMatchCard';
import RenderGenericMatchCard from './SingleMatchCardPrimeArchivioFunctions/RenderGenericMatchCard';
import { TopDecorColor } from '../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';

const ContainerSingleBestYear = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    background: linear-gradient(160deg, rgba(90, 15, 15, 0.9) 0%, rgba(25, 25, 25, 0.98) 100%);
    border: 2px solid rgba(255, 255, 255, 0.25);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    margin: 10px 0;
    padding: 20px 0 10px 0;

    & h1.title-best-year {
        font-size: 16px;
        font-weight: 800;
        color: white;
        margin: 10px 0;
        padding: 0;
    }

    & h2 {
        text-align: center;
        color: white;
        //collapse
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }
`;

const BoxAllMatchesYear = styled.div`
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: center;
    width: 95%;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px 0;
`;



function PrimeWrestlerRender({ bestYears, wrestlerId }) {
    //Navigazione al ppv
    const navigate = useNavigate();

    // Containerone Best Single Year
    const renderBestYear = (bestYear, key) => {

        const matchesYear = bestYear.matches;

        return (
            <ContainerSingleBestYear key={key} className='container-single-best-year'>
                <TopDecorColor />

                <h1 className='title-best-year'>{bestYear.year}</h1>

                <BoxAllMatchesYear className='box-all-matches-year'>
                    {matchesYear.map((match, keyMatch) => (
                        match.type_match.type === "single" ? (
                                RenderSingleMatchCard(match, keyMatch, wrestlerId)
                            ) : (
                                RenderGenericMatchCard(match, keyMatch, wrestlerId)
                            )
                        )
                    )}
                </BoxAllMatchesYear>
            </ContainerSingleBestYear>
        )
    }

    // JSX 
    return (
        <GenericRenderContainerSection 
            className='prime-wrestler-render'
            width='100%'
            padding='10px'
        >
            <p className='info-section info-prime-wrestler'>
                Gli anni più importanti della sua carriera. Cliccando sul match, si viene indirizzati al PPV.
            </p>

            {bestYears.map((bestYear, key) => (
                renderBestYear(bestYear, key)
            ))}
        </GenericRenderContainerSection>
    )
}

export default PrimeWrestlerRender;